/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class profileContactDetailsPhoneEdit extends mixinBehaviors([accessibilityBehaviours.commonFunctions, sbBehaviours.authAndSubmit, corpBehaviours.appCommonBehaviour], PolymerElement) {
        static get template() {
            return html `
        <style  include="app-styles">  
          .marginRight2{
            margin-right:2%;
          }
          .buttonPosition{
            position: absolute;
            align-content: center;
            bottom: 0;
            padding-bottom: 3%;
          }
          .buttonHeight{
            // position: absolute;
            // bottom: 13%;
            // right: 9%;
            position: relative;
            margin-top: 75%;
          }
          oe-input{
            --paper-input-container-ms-clear: {
                    color: white;
                    height: 0;
                    width: 0;
              }
          }
        </style>
        <app-media-query phone={{phone}} tablet={{tablet}} desktop={{desktop}}></app-media-query>
        <div class="mdl-grid mdl-grid--no-spacing" hidden$={{phone}}>
          <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col content-align-left text-align-left">
            <div hidden$="{{displayIcon(leftAction.leftIcon)}}">
              <a href="{{leftAction.lefthref}}" tabIndex="-1" hidden$="{{leftAction.leftCallback}}">
                <paper-icon-button icon="{{leftAction.leftIcon}}" class="action-btn-rtl"></paper-icon-button>
              </a>
              <div hidden$="{{!leftAction.leftCallback}}">
                <paper-icon-button id="phone_edit_back_button" icon="{{leftAction.leftIcon}}" on-tap="_confirmBack" aria-label$="{{getLabel('l_Back')}}" role="button" class="action-btn-rtl"></paper-icon-button>
              </div>
            </div>
          </div>
          <div class="outlineOffset mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col content-align-center text-align-center title-dark" tabindex=0 id="phone_edit_page_title">
            <oe-i18n-msg msgid="{{titlePage}}"></oe-i18n-msg>
          </div>
        </div>
        <div class="mdl-grid">
          <div class="justify-content-space-bwn mdl-grid margin-b-zero mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col">
          <oe-combo class="mdl-cell--4-col" id='communication_add_home_number' label="l_CountryCode" listurl='/api/codereferences?filter[where][codeType]=CNTC' 
                displayproperty='codeDescription' valueproperty='cmCode' value='{{selectedPhoneDetails.contactNumberCountryCode}}'>
              </oe-combo>
            <oe-input class="mdl-cell--8-col" wide-layout$="{{tablet}}" extra-wide-layout$="{{desktop}}" id='phone_number' value={{selectedPhoneDetails.contactNumber}}
              label="{{selectedPhoneDetails.editLabel}}"></oe-input>
          </div>
          <template is="dom-if" if="{{!selectedPhoneDetails.alwaysPreferred}}">
            <div class="content-align-vertical-center full-width margin-l-zero mdl-grid">
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-disabled="true" aria-checked="false" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked marginRight2" hidden={{selectedPhoneDetails.preferredContact}} on-tap="_checkUncheckPreference" ></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-disabled="true" aria-checked="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-checked marginRight2" hidden={{!selectedPhoneDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
              <oe-i18n-msg class="font-size-m" msgid="l_setAsPreferedPhoneNumber"></oe-i18n-msg>
            </div>
          </template>
          <template is="dom-if" if="{{selectedPhoneDetails.alwaysPreferred}}">
            <template is="dom-if" if="{{selectedPhoneDetails.isContactPresent}}">
              <div class="content-align-vertical-center full-width margin-l-zero mdl-grid">
                      <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="false" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked cursor-pointer marginRight2" hidden={{selectedPhoneDetails.preferredContact}} on-tap="_checkUncheckPreference" ></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-checked cursor-pointer text-brand-color marginRight2" hidden={{!selectedPhoneDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
                  <oe-i18n-msg class="font-size-m" msgid="l_setAsPreferedPhoneNumber"></oe-i18n-msg>
              </div>
            </template>
            <template is="dom-if" if="{{!selectedPhoneDetails.isContactPresent}}">
              <div class="content-align-vertical-center full-width margin-l-zero mdl-grid">
                      <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="false" aria-disabled="true" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked marginRight2" hidden={{selectedPhoneDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="true" aria-disabled="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-unchecked marginRight2" hidden={{!selectedPhoneDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
                  <oe-i18n-msg class="font-size-m disabled-dark-color" msgid="l_setAsPreferedPhoneNumber"></oe-i18n-msg>
              </div>
            </template>
          </template>
        </div>
        <template is="dom-if" if="{{phone}}">
          <div class="mdl-grid">
            <div class="buttonPosition mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
              <paper-button id="phone_update_btn" on-keydown = "setFocus" on-tap="_updatePhone" class="primary-button">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
              </paper-button>
            </div>
          </div>
        </template>
        <template is="dom-if" if="{{!phone}}">
          <div class="mdl-grid buttonHeight">
            <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
              <paper-button id="phone_update_btn" on-keydown = "setFocus" on-tap="_updatePhone" class="primary-button">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
              </paper-button>
            </div>
          </div>
        </template>

        <!-- app dialog for authorization i.e. transaction  password -->
        <app-dialog name="h_Authorization" id="phoneUpdateAuthorization" elementid="phoneUpdateAuthorization">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                <fin-auth-element-wrapper id="loan_acct_phone_form_authPaymentStopWrapper" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitLoanPhoneFormAuthsubmit" on-tap="_continueToConfirm" on-keypress="_continueToConfirm" class="flat-button">
                  <oe-i18n-msg id="submitLoanPhoneFormAuthsubmitLabel" class="text-brand-color" msgid="b_Submit"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>

        <app-dialog id="backNagigationPopup" closevisible="{{closevisible}}" elementid="backNagigationPopup">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
              <oe-i18n-msg msgid="m_backNavigationError" class="font-size-m"></oe-i18n-msg>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_leftAction" on-keypress="_leftAction" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_Yes"></oe-i18n-msg>
                </paper-button>
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_cancelBack" on-keypress="_cancelBack" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_No"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>
          `;
        }

        static get properties() {
            return {
                //To store page title
                titlePage: {
                    type: String,
                    notify: true
                },
                minmobilelength: {
                  type: Number,
                  value: 10
                },
                maxmobilelength: {
                  type: Number,
                  value: 13
                },

                //Iron page selector for pages in profile-main
                myprofilepagenumber: {
                    type: Number,
                    notify: true,
                    observer: 'resetAuth'
                },
                //Details of the selected phone
                selectedPhoneDetails: {
                    type: Object,
                    notify: true
                },
                //To store authentication methods
                authMethods: {
                    type: Array,
                    notify: true
                },
                //To store all the address and contact details
                commDetails: {
                    type: Array,
                    notify: true
                },
                //To hide close button from back navigation popup
                closevisible: {
                    type: Boolean,
                    value: false
      },
      fromPhoneEditPage: {
        type: Boolean,
        value: false,
        notify: true
      },
      personalDetailsResponse: {
        type: Array,
        notify: true
      }
            };
        }

        static get observers() {
            return ['phoneNumberChanged(selectedPhoneDetails.contactNumber)'];
        }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('iron-overlay-closed', this._clearAuthMethods);
  }
  _clearAuthMethods() {
    this.authMethods = [];
  }
        //To reset authmethods
        resetAuth(n) {
            if (n == 10) this.authMethods = [];
        }

        //Called when phone number is changed
        phoneNumberChanged(number) {
            if (typeof number == "number" && number >= 0) {
                this.set('selectedPhoneDetails.isContactPresent', true);
            } else if (typeof number == "string") {
                if (number == "") this.set('selectedPhoneDetails.isContactPresent', false);
                else this.set('selectedPhoneDetails.isContactPresent', true);
            } else if (number == undefined) {
                this.set('selectedPhoneDetails.isContactPresent', false);
            }
        }

        //To check if user has changed the values
        _confirmBack() {
            if (this.selectedPhoneDetails.contactNumber == this.selectedPhoneDetails.originalPhone && this.selectedPhoneDetails.tempFlag == true) {
                this.myprofilepagenumber = 8;
            } else {
                this.$.backNagigationPopup.$$("#backNagigationPopup").open();
            }
        }

        //cancel back navigation
        _cancelBack() {
            this.$.backNagigationPopup.$$("#backNagigationPopup").close();
        }

        //To navigate back
        _leftAction() {
                this.$.backNagigationPopup.$$("#backNagigationPopup").close();
                this.$$("#phone_number").invalid = false;
                this.myprofilepagenumber = 8;
            } //To display the back icon


        displayIcon(value) {
            if (value == "") return true;
            return false;
        }

        //To set the preferred type
        _checkUncheckPreference() {
                var self = this;
                if (this.selectedPhoneDetails.preferredcmCode != this.selectedPhoneDetails.cmCode) {
                    if (this.selectedPhoneDetails.isContactPresent) {
                        if (this.selectedPhoneDetails.preferredContact) {
                            this.set('selectedPhoneDetails.preferredContact', false);
                            this.selectedPhoneDetails.tempFlag = !this.selectedPhoneDetails.tempFlag;
                            setTimeout(function() {
                                self.shadowRoot.querySelector('#unchecked_icon').focus();
                            }, 500);
                        } else {
                            this.set('selectedPhoneDetails.preferredContact', true);
                            this.selectedPhoneDetails.tempFlag = !this.selectedPhoneDetails.tempFlag;
                            setTimeout(function() {
                                self.shadowRoot.querySelector('#checked_icon').focus();
                            }, 500);
                        }
                    }
                }
            } //Validates and calls the post api


        _updatePhone() {
            if (this.selectedPhoneDetails.contactNumber != "" && this.selectedPhoneDetails.contactNumber.match(/^[0-9]*$/) && !_.isUndefined(this.selectedPhoneDetails.contactNumberCountryCode)) {
                this.$$("#phone_number").invalid = false;

                if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
                    this.authMethods = [];
                    this.header = [];
                }

                var self = this;
                var preferredContact = ""; // var contactDetails = {};
                if (self.commDetails[0].contactDetails) {
                    for (let i = 0; i < self.commDetails[0].contactDetails.length; i++) {
                        if (self.commDetails[0].contactDetails[i].contactType.codeType == "PFPH") {
                            if (self.commDetails[0].contactDetails[i].contactType.cmCode == this.selectedPhoneDetails.cmCode) {
								var contactDetails = self.commDetails[0].contactDetails[i];
								var contactId = self.commDetails[0].contactDetails[i].contactId;
							}
                            if (self.selectedPhoneDetails.preferredContact == true) preferredContact = self.selectedPhoneDetails.cmCode;
                            else if (self.selectedPhoneDetails.preferredContact == false) preferredContact = "";
                            else if (self.commDetails[0].contactDetails[i].preferredContact.cmCode == "Y") preferredContact = self.commDetails[0].contactDetails[i].contactType.cmCode;
                        }
          else  if (this.selectedPhoneDetails.codeType=="PFPH"){
            if (self.selectedPhoneDetails.preferredContact == true) 
              preferredContact = self.selectedPhoneDetails.cmCode; 
            else if (self.selectedPhoneDetails.preferredContact == false) 
              preferredContact = ""; 

            
          }
        }
      }

      else if (self.commDetails[0].contactDetails == undefined) {
        if (self.selectedPhoneDetails.preferredContact == true) preferredContact = self.selectedPhoneDetails.cmCode; else if (self.selectedPhoneDetails.preferredContact == false) preferredContact = "";
        else if (self.commDetails[0].contactDetails[i].preferredContact.cmCode == "Y") preferredContact = self.commDetails[0].contactDetails[i].contactType.cmCode;
      }

                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/contactdetailsrequests';
                ajaxCall.method = 'POST';
                ajaxCall.body = {};
                ajaxCall.body["customerId"] = clientStorage.get(storageType.session, 'customerId');
				if(!self.commDetails[0].contactDetails && preferredContact== ""){
					ajaxCall.body["preferredContact"] = self.selectedPhoneDetails.cmCode;
				}
				else{
					ajaxCall.body["preferredContact"] =preferredContact;
				}
                ajaxCall.body["preferredContact"] = preferredContact;
                ajaxCall.body[self.selectedPhoneDetails.cType] = {}
                ajaxCall.body[self.selectedPhoneDetails.cType]["id"] = contactId;
                ajaxCall.body[self.selectedPhoneDetails.cType]["contact"] = {}
                ajaxCall.body[self.selectedPhoneDetails.cType]["contact"]["contactNumberCityCode"] = "";
                ajaxCall.body[self.selectedPhoneDetails.cType]["contact"]["contactNumberCountryCode"] = self.selectedPhoneDetails.contactNumberCountryCode;
                ajaxCall.body[self.selectedPhoneDetails.cType]["contact"]["contactNumber"] = self.selectedPhoneDetails.contactNumber;
                ajaxCall.body[self.selectedPhoneDetails.cType]["contact"]["workExtNum"] = "";
                console.log(ajaxCall.body);

                oeAjaxEventListner(ajaxCall);
                this.submitDetails(ajaxCall.url, ajaxCall.method, ajaxCall.body, this.header);
            } else {
             if (_.isUndefined(this.selectedPhoneDetails.contactNumberCountryCode)) {
                this.fire('oe-show-error', {
                        message: getLabel('l_enter_countryCode')
                    });
                } else {
                    this.fire('oe-show-error', {
                    message: getLabel('l_validPhoneNumberErr')
                });
                this.$$("#phone_number").invalid = true;
            }
        }
}
        //To open auth page to enter Txn password
        _callAuthPage() {
            this.$.phoneUpdateAuthorization.$$("#phoneUpdateAuthorization").open();
        }

        //To display success toast
        _callSucessPage(e) {
            this.$.phoneUpdateAuthorization.$$("#phoneUpdateAuthorization").close();
            this.myprofilepagenumber = 8;
            var successMsg;
            var errorMsg;
            var reqStatusCode=e.detail.response.requestStatus.cmCode;
            if(reqStatusCode=="SUC")
            successMsg = getLabel('l_phoneNumberWasUpdatedSuccessfully');
            else if(reqStatusCode=="PEN" || reqStatusCode=="SUB"||reqStatusCode=="SUS")
            successMsg = getLabel("m_RequestSubmittedSuccessfullyForReferenceId")+e.detail.response.requestRefNo;
            else if(reqStatusCode=="ENT")
            successMsg = getLabel("m_RequestSucSubmitApproval")+e.detail.response.requestRefNo;
            else if(reqStatusCode=="PFC")
            successMsg = getLabel("m_RequestSucSubmitPending")+e.detail.response.requestRefNo;
            else if(reqStatusCode=="FAL")
            errorMsg= getLabel("l_phoneNumberUpdatedFail");
            if(successMsg){
              this.fire('oe-show-success', {
                message: successMsg
            });
      this.fromPhoneEditPage = true;
    } else {
              this.fire('oe-show-error', {
                message: errorMsg
            });
            }
        //code changes for 396752
        }

        //To set the auth methods
        _continueToConfirm() {
            if (this.authenticationValidation(this.authMethods)) return;
            if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

            if (this.authMethods && this.authMethods.length == 2) {
                this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
                this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
            }

            this._updatePhone();
        }

        //Manually focused on Header
        _focusOnTitle() {
            setTimeout(function() {
                this.$$("#phone_edit_page_title").setAttribute("tabindex", "0");
                this.$$("#phone_edit_page_title").focus();
            }.bind(this), 0);
        }
        setFocus(event) {
            if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
                this.shadowRoot.querySelector("#phone_edit_page_title").focus();
            }
        }

    } // Associate the new class with an element name


customElements.define('profile-contact-details-phone-edit', profileContactDetailsPhoneEdit);